import clsx from 'clsx';

import type { ComponentProps } from 'react';

import s from './ModalContent.module.css';

type ModalContentProps = ComponentProps<'div'>;

export const ModalContent = ({ children, className, ...props }: ModalContentProps) => (
  <div className={clsx(s.content, className)} {...props}>
    {children}
  </div>
);
